<mat-selection-list class="listAccessory" (selectionChange)="onChangeSlot(slotList.selectedOptions.selected)" #slotList>
    <mat-list-option class="listSlotOption" *ngFor="let slot of slots_to_show" [value]="slot" >
        {{slot.startDateTime | date:'HH:mm'}} -
        {{(slot | accessorySlotStatus | translate).replace("%1",slot.slots.length)}}
    </mat-list-option>
</mat-selection-list>
